import React from 'react';
import { node, string, bool } from 'prop-types';
import cx from 'classnames';

import styles from './icon-layout.scss';

/*
  This component scales and aligns a child svg inline with the text. By default
  the icon is aligned with the text baseline. The alignMiddle option centers
  the icon vertically.
*/

export default function IconLayout({ children, className, alignMiddle }) {
  return (
    <span
      className={cx(styles.main, className, {
        [styles.alignMiddle]: alignMiddle,
      })}
    >
      {children}
    </span>
  );
}

IconLayout.propTypes = {
  children: node.isRequired,
  className: string,
  alignMiddle: bool,
};

IconLayout.defaultProps = {
  alignMiddle: false,
};



// WEBPACK FOOTER //
// ./src/components/IconLayout/index.js